import "./header.css";


const Header = () => {
  return (
    <>
      <div id="header">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="img-container">
                <img src="https://www.leivahnos.com.ar/wp-content/uploads/2024/06/leiva_2024.png" alt="Leiva Hermanos Branding" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}


export default Header;

